var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.32 10.82H22.28V7.44C22.28 6.64 21.64 6 20.84 6H12.44C11.64 6 11 6.64 11 7.44V41.56C11 42.36 11.64 43 12.44 43H20.86C21.66 43 22.3 42.36 22.3 41.56V24.4H34.34C38.1 24.4 41.14 21.36 41.14 17.6C41.14 13.86 38.08 10.82 34.32 10.82ZM34.32 20.46H22.28V14.78H34.32C35.88 14.78 37.16 16.06 37.16 17.62C37.18 19.18 35.9 20.46 34.32 20.46Z",
    fill: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassing);
export default ForwardRef;